import type * as models from './models'

/**
 * {@link https://ngrx.io/docs State} of this plugin
 */
export interface State {
  /**
   * The {@link  models.page.Rendering rendering} of the currently selected mosaic page.
   */
  rendering?: models.page.Rendering
  /**
   * Error that occurs during page rendering load. When page loads successfully,
   * this value is undefined.
   *
   * @default undefined
   */
  renderingError?: Error | string
  /**
   * Whether the page rendering is currently in a loading state.
   *
   * This defaults to `true` because we know the data will be loaded initially.
   *
   * @default true
   */
  isRenderingLoading?: boolean
}
export namespace State {
  export const INITIAL: NoMissing<State> = {
    isRenderingLoading: true,
    rendering: undefined,
    renderingError: undefined,
  }

  /**
   * Sets the {@link State.rendering} for the selected mosaic page and disables
   * the loading state.
   */
  export function setRendering(
    state: State,
    rendering: models.page.Rendering,
  ): State {
    return { ...state, isRenderingLoading: false, rendering }
  }

  /**
   * resets the {@link State.rendering}
   */
  export function deleteRendering(state: State): State {
    return { ...state, rendering: undefined }
  }

  export function setRenderingLoading(
    state: State,
    { isLoading }: { isLoading: boolean },
  ): State {
    return { ...state, isRenderingLoading: isLoading }
  }

  /**
   * Updates {@link State.renderingError} with the specified error and disables
   * {@link State.isRenderingLoading} state.
   *
   * Loading state is automatically disabled since an error indicates completion of the operation.
   */
  export function setRenderingError(
    state: State,
    { error }: { error: string | Error },
  ): State {
    return { ...state, isRenderingLoading: false, renderingError: error }
  }
}
